export default __webpack_public_path__ + "static/media/categoria_adm.de636671.svg";